import { CancelIcon } from 'BreetAssets';
import { SelectInput } from 'BreetComponents';

import type { ITableFilterProps } from './TableFilter.helpers';

const TableFilter = ({ onResetFilter, filterItems }: ITableFilterProps) => (
	<div className='appfilter dropdownshadow'>
		<CancelIcon
			className='svg-dark svg-dark-outline svg-dark-fill-circle cursor_pointer appfilter_closeicon'
			variant='dropdown'
			aria-label='Reset filters'
			role='button'
			tabIndex={0}
			onClick={onResetFilter}
		/>

		{filterItems.map((filterItem, index) => (
			<SelectInput
				{...filterItem}
				key={`${filterItem.label}-${index}`}
			/>
		))}
	</div>
);

export default TableFilter;
